import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_aging_period_hdr_RowClass, bl_fi_aging_period_line_RowClass,  } from "../../../dbschema";

export class AgingPeriodContainerModel extends BaseContainerModel {
  bl_fi_aging_period_hdr: bl_fi_aging_period_hdr_RowClass = new bl_fi_aging_period_hdr_RowClass();
  bl_fi_aging_period_line: bl_fi_aging_period_line_RowClass[] = [];
}
